import { render } from "./BasicSearch.vue?vue&type=template&id=4cd93732&scoped=true"
import script from "./BasicSearch.vue?vue&type=script&lang=js"
export * from "./BasicSearch.vue?vue&type=script&lang=js"

import "./BasicSearch.vue?vue&type=style&index=0&id=4cd93732&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd93732"]])

export default __exports__